// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"931":"6820b896","4507":"401576b2","4821":"8bb4856f","6226":"3d7f09cd"}[chunkId] + ".chunk.css";
};